/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
  home_active: 1,
  home_left: 0,
  home_titleColor: 0,
};
